export default {
    "facet": {
        "show_text_view": "Text anzeigen",
        "show_chart_view": "Chart anzeigen",
        "itemExclude": "Exkludieren",
        "applyFilters": "{selections, plural, one {Filter anwenden} other {Filter anwenden}}",
        "clearFilters": "{selected, plural, one {Filter löschen} other {Filter löschen}}",
        "loadMore": "Mehr laden",
        "showMore": "Mehr anzeigen",
        "showLess": "Weniger anzeigen",
        "displayed": "Angezeigt",
        "removeAll": "Alle entfernen",
        "searchPlaceholder": "Suche...",
        "itemSelect": "Diesen Wert auswählen",
        "filterItems" : "Behalte Dokumente mit MINDESTENS EINEM der ausgewählten Werte",
        "filterItemsAnd": "Behalte Dokumente mit ALLEN ausgewählten Werten",
        "excludeItems" : "Exckludiere Dokumente mit den ausgewählten Werten",
        "clearSelects" : "Entferne die aktuellen Filter",
        "searchItems" : "Suche nach eniem Wert in dieser Liste",
        "searchNoResult": "Keine Ergebnisse",
        "openItem": "Öffnen",
        "closeItem": "Schließen",
        "authors": {
            "title": "Autoren"
        },
        "concepts": {
            "title": "Konzepte"
        },
        "company": {
            "title": "Firmen"
        },
        "docformat": {
            "title": "Formate"
        },
        "doctype": {
            "title": "Dokumenttypen"
        },
        "documentlanguages": {
            "title": "Sprachen"
        },
        "fileext": {
            "title": "Dateierweiterungen"
        },
        "filename": {
            "title": "Dateinamen"
        },
        "geo": {
            "title": "Orte"
        },
        "matchingpartnames": {
            "title": "Übereinstimmende Partnames"
        },
        "modified": {
            "title": "Datumsangaben"
        },
        "person": {
            "title": "Personen"
        },
        "refine": {
            "title": "Suche verfeinern",
            "input": {
                "label": "Verfeinern",
                "buttonTitle": "Verfeinern",
                "placeholder": "Verfeinern nach..."
            }
        },
        "size": {
            "title": "Größen"
        },
        "tagcloud": {
            "title": "Wortwolke"
        },
        "title": {
            "title": "Titel"
        },
        "treepath": {
            "title": "Quellen"
        },
        "recentQueries": {
            "title": "Kürzliche Suchanfragen"
        },
        "recentQueriesPublic": {
            "title": "Kürzliche öffentliche Suchanfragen"
        },
        "mySearch": {
            "title": "Meine Suche",
            "itemRemove": "Entfernen"
        },
        "search": {
            "label": "Suche",
            "buttonTitle": "Suche",
            "placeholder": "Suche...",
            "showSearchForm": "Suchmaske einblenden",
            "hideSearchForm": "Suchmaske ausblenden"
        },
        "range": {
            "year": "{date, date, sqYear}",
            "monthYear": "{date, date, sqMonthYear}",
            "weekYear": "W{week, number, sqWeek} {weekYear, number, sqYear}",
            "apply": "Anwenden",
            "clear": "Löschen",
            "unavailable": "Kein Bereich verfügbar"
        },

        "filters":{
            "add":"Filter hinzufügen",
            "addAll": "Alle Facetten hinzufügen",
            "remove":"Filter entfernen",
            "removeAll": "Alle Facetten entfernen",
            "setDefaults": "Standardfacetten",
            "clear":"Filter löschen",
            "moreFilters":"",
            "showFilters":"Filter einblenden",
            "hideFilters":"Filter ausblenden",

            "back": "Zurück zu den Filtern",
            "selectedFilters": "Dieser Filter ist in der aktuellen Suchanfrage aktiv",

            "customizeFacets": "Facetten zum Anzeigen oder Ausblenden auswählen"
        },

        "selectedValue": "Dieser Wert ist in der aktuellen Anfrage ausgewählt.",
        "previous": "Zurück",
        "next": "Weiter",
        "filterItemCountTooltip": "{count} mögliche Werte für diesen Filter",
    },

    "facetCard": {
        "expand": "Erweitern",
        "collapse": "Reduzieren",
        "enlarge": "Vergrößern",
        "reduce": "Reduzieren",
        "openSettings": "Einstellungen öffnen",
        "saveSettings": "Einstellungen speichern"
    }
};
